<template>
  <img src="~/assets/icon/black-wallet.svg" />
</template>
